/** Collection visits about this many sources per minute. */
export const SOURCES_PER_MINUTE = 8;
/** Rough model cost per article sorted, in dollars. */
export const COST_PER_ARTICLE_USD = 0.0005;
/** A classification run stops itself past this spend. */
export const CLASSIFY_STOP_USD = 50;

/** Whole hours a full collection of `sources` takes, rounded up; 0 when there is nothing to visit. */
export function estimateCollectHours(sources: number): number {
  if (!Number.isFinite(sources) || sources <= 0) return 0;
  return Math.ceil(sources / SOURCES_PER_MINUTE / 60);
}

export function collectHoursLabel(sources: number | null): string {
  if (sources === null) return "a few hours";
  const hours = estimateCollectHours(sources);
  return `about ${hours} ${hours === 1 ? "hour" : "hours"}`;
}

export function estimateClassifyCostUsd(articles: number): number {
  return Number.isFinite(articles) && articles > 0 ? articles * COST_PER_ARTICLE_USD : 0;
}

/** "roughly $C" (whole dollars), or "under $1" when it is below a dollar. */
export function classifyCostLabel(articles: number | null): string {
  if (articles === null) return "a few dollars";
  const cost = estimateClassifyCostUsd(articles);
  return cost < 1 ? "under $1" : `roughly $${Math.round(cost)}`;
}
